import { jsx as f, Fragment as L } from "react/jsx-runtime";
import c, { forwardRef as O, useRef as _ } from "react";
import { useIsDisabledWithTooltipEnabled as v } from "./index.es590.js";
import { getTooltipByConditions as z } from "./index.es554.js";
import { useEnrichTooltipOpenState as A } from "./index.es128.js";
import { mergeRefs as m } from "./index.es551.js";
import { SimpleTooltip as B } from "./index.es127.js";
const K = O(
  ({
    children: l,
    tooltip: o,
    isLocked: a = !1,
    lockedTooltip: d,
    itemLabel: T,
    isDisabled: g = !1,
    isOverflowing: h = !1,
    ...u
  }, n) => {
    const e = _(null);
    let i, p = {}, r;
    const P = v();
    if (typeof o == "string")
      i = o;
    else if (o) {
      const t = o;
      i = t.title, t.tooltipPositioning && (p = t.tooltipPositioning), r = t.lockedTooltip;
    }
    const E = d || r, { isTooltipOpen: b, enrichTooltipProps: k } = A({
      ref: e
    }), { tooltipTitle: x, showTooltip: s } = z({
      tooltip: i,
      isLocked: a,
      lockedTooltip: E,
      itemLabel: T,
      isDisabled: g,
      isOverflowing: h
    }), {
      maxWidth: y,
      placement: R = "top",
      align: S,
      offset: W,
      hidePointer: j,
      zIndex: w,
      appendToParent: I
    } = p;
    return !s || !P ? /* @__PURE__ */ f(L, { children: c.cloneElement(l, {
      ref: m(e, n)
    }) }) : /* @__PURE__ */ f(
      B,
      {
        title: x,
        maxWidth: y,
        placement: R,
        align: S,
        offset: W,
        hidePointer: j,
        zIndex: w,
        appendToParent: I,
        isActive: s,
        open: b,
        ...u,
        children: c.cloneElement(l, {
          ref: m(e, n),
          ...k
        })
      }
    );
  }
);
export {
  K as SmartTooltipWrapper
};
//# sourceMappingURL=index.es525.js.map
